import { Record } from "immutable";
import { RootActions, RootState } from "common/reducers";
import { DECREMENT_LOADING, INCREMENT_LOADING, RESET_LOADING } from "common/reducers/ui.actions";

export const UiStateRecord = Record({
  loadingCounter: 0,
});

export const initialState = UiStateRecord({ loadingCounter: 0 });
export type UiState = typeof initialState;

const model = "ui";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (!state.get("ui")) {
    state = state.set("ui", initialState);
  }

  switch (action.type) {
    case INCREMENT_LOADING: {
      return state.updateIn([model, "loadingCounter"], (current) => current + 1);
    }

    case DECREMENT_LOADING: {
      return state.updateIn([model, "loadingCounter"], (current) => Math.max(0, current - 1));
    }

    case RESET_LOADING: {
      return state.updateIn([model, "loadingCounter"], (_current) => 0);
    }

    default:
      return state;
  }
};
